import React from 'react';
import './possibility.css';

import possibilityImage from '../../assets/possibility.png';

const Possibility = () => {
    return (
        <div className='gpt3__possibility section__padding' id='possibility'>
            <div className='gpt3__possibility-image'>
                <img src={possibilityImage} alt="possibility" />
            </div>

            <div className='gpt3__possibility-content'>
                <h4>Engineered for professionals.</h4>

                <h1 className='gradient__text'> Unlock the Full Potential of Your ECU</h1>

                <p>Prinzetuner provides the ultimate control over vehicle performance. From secure binary processing to intelligent pattern detection, our tools are built for tuners who demand accuracy beyond ordinary tuning solutions.</p>

                <h4>Precision. Power. Control.</h4>
            </div>
        </div>
    )
}

export default Possibility
